import { StandardEvents } from '@shopify/events';

/** Reuse Horizon's server-rendered variant response, with no extra network request. */
class NgProductAvailability extends HTMLElement {
  #section;
  #revision = 0;

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#onProductSelect);
  }

  disconnectedCallback() {
    this.#revision++;
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#onProductSelect);
  }

  #onProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;
    const revision = ++this.#revision;
    event.promise?.then(({ detail }) => {
      if (!this.isConnected || revision !== this.#revision || !detail?.html) return;
      if (!detail.newProduct && detail.productId && String(detail.productId) !== this.dataset.productId) return;
      const next = detail.html.querySelector(
        `ng-product-availability[data-block-id="${CSS.escape(this.dataset.blockId)}"]`
      );
      if (!next) return;
      this.dataset.productId = next.dataset.productId;
      this.dataset.price = next.dataset.price;
      this.dataset.currency = next.dataset.currency;
      this.replaceChildren(...Array.from(next.childNodes, (node) => node.cloneNode(true)));

      if (this.dataset.primaryProduct === 'true') {
        for (const meta of document.querySelectorAll('meta[property$="price:amount"]')) {
          meta.setAttribute('content', next.dataset.price);
        }
        for (const meta of document.querySelectorAll('meta[property$="price:currency"]')) {
          meta.setAttribute('content', next.dataset.currency);
        }
      }
    }).catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[ng-product-availability]', error);
    });
  };
}

if (!customElements.get('ng-product-availability')) {
  customElements.define('ng-product-availability', NgProductAvailability);
}
